import pptp from "./pptp.json";

export default { pptp };
